import React from "react";
import { Link } from "react-router-dom";
import { useUser } from "../context/UserContext";

const API_BASE_URL = "https://pevbackend.codovio.com/public/uploads/profile_pictures/";

const Profile = () => {
  const { userData } = useUser();
  const username = userData.username || "User";
  const profilePicture = userData.profile_picture || null;
  const initials = username
    .split(" ")
    .map((name) => name[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const getImageUrl = (imageValue) => {
    if (!imageValue) return null;
    if (imageValue.startsWith("http")) return imageValue;
    return `${API_BASE_URL}${imageValue}`;
  };

  const imageUrl = getImageUrl(profilePicture);

  return (
    <Link to="/profile" className="text-decoration-none text-dark">
      <div className="d-flex align-items-center gap-2">
        <div
          className="rounded-circle bg-primary-600 text-white d-flex align-items-center justify-content-center"
          style={{ width: 40, height: 40 }}
        >
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="profile"
              className="rounded-circle"
              style={{ width: 40, height: 40, objectFit: "cover" }}
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
          ) : (
            <span className="fw-semibold">{initials}</span>
          )}
          <span
            className="fw-semibold"
            style={{ display: imageUrl ? "none" : "flex" }}
          >
            {initials}
          </span>
        </div>
        <span className="fw-medium text-primary-light">{username}</span>
      </div>
    </Link>
  );
};

export default Profile;